import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createOtellConType = ( {data} : {data: IPostNewOtellConType | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/OteIIConTypes/InsertOteIIConType`, data);
};

type QueryFnType = typeof createOtellConType;

type UseCreateOtellConTypeOptions = {
  data: IPostNewOtellConType | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreateOtellConType = ({ config }: UseCreateOtellConTypeOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Είδους τηλεπ. γραμμής ΟΤΕ.`, 500);
            console.error('Couldnt create new OtellConType', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllOtellConTypes"])
            addNotification(`Δημιουργήθηκε Νέο Είδος τηλεπ. γραμμής ΟΤΕ.`, 200);
            setIsNotificationVisible(true)  
          },
        ...config,
        mutationFn: createOtellConType,
    })
}